import { useNavigate } from "@tanstack/react-router";
import { useCallback } from "react";

/**
 * Returns an onNavigate function that uses TanStack Router for
 * client-side navigation. Designed to be passed into host configs.
 */
export function useHostNavigate(): (path: string) => void {
  const navigate = useNavigate();

  return useCallback(
    (path: string) => {
      void navigate({ to: path });
    },
    [navigate],
  );
}
